const cartWidget = () =>{

    return (
        <i className="fa-solid fa-cart-shopping"></i>
    )
}

export default cartWidget